import { ORGANIZATION_KINDS, type OrganizationRaw, type OrganizationRow } from "~/features/admin/organizations/types";

/** API row → table row. */
function toOrganizationRow(raw: OrganizationRaw): OrganizationRow {
  return {
    id: raw.id,
    name: raw.name,
    shortCode: raw.shortCode,
    // The column reads back as a plain string; unknown kinds fall back to
    // "business" (fail neutral) rather than silently claiming "consumer".
    kind: ORGANIZATION_KINDS.find((k) => k === raw.kind) ?? "business",
    createdAt: raw.createdAt,
    isDeactivated: Boolean(raw.deactivatedAt),
  };
}

export function toOrganizationRowList(raws: readonly OrganizationRaw[]): OrganizationRow[] {
  return raws.map(toOrganizationRow);
}
